import { useTranslation } from "react-i18next";

import Progress from "../../../ExamComponents/Progress";

export default function CourseProgress({ row }) {
	const { t } = useTranslation();

	if (!row?.lessons) {
		return (
			<Progress resolvedItems={0} allItems={0} unit={t("units.lessons")} />
		);
	}

	const resolvedItems = row.lessons.filter(
		(lesson) => lesson.status === "resolved",
	);

	return (
		<Progress
			resolvedItems={resolvedItems.length}
			allItems={row.lessons.length}
			unit={t("units.lessons")}
		/>
	);
}
